<template>
 <div class="account-right-item download">
  <h4>我下载的作品</h4>
  <div v-if="page.total!=0">
    <ul>
      <li class="download-list clearfix" v-for="item in download_list">
        <div class="fl">
          <img :src="item.app_logo" alt="" width="88" height="88"/>
        </div>
        <div class="right-wrapper">
          <h5>{{item.app_name}}
            <span class="green" v-if="item.price == 0" >免费</span>
            <span class="tip" v-else><strong class="orange">{{item.price}}</strong> {{ item.money_type == 0? '现金' : '鲸币' }}</span>
          </h5>
          <div class="download-details more"><span>展开</span><i></i></div>
          <p v-html="item.tip"></p>
          <ul class="download-infor">
            <li class="clearfix">
              <span class="title fl">作品人</span>
              <p class="fl">{{item.nick_name}}</p>
            </li>
            <li class="clearfix">
              <span class="title fl">作品类型</span>
              <p class="fl">{{item.sys_type}}</p>
            </li>
             <!-- <li class="clearfix">
              <span class="title fl">作品价格</span>
              <p class="fl">免费</p>
            </li> -->
            <li class="clearfix">
              <span class="title fl">服务支持</span>
              <p class="fl">{{item.support}}（<span :class="{'green':!item.is_expired,'overdue':item.is_expired}">{{item.is_expired ? '已过期' : '有效期内'}}</span>）</p>
            </li>
            <li class="clearfix">
              <span class="title fl">下载日期</span>
              <p class="fl">{{item.download_at}}</p>
            </li>
            <li class="clearfix">
              <span class="title fl">更新时间</span>
              <p class="fl">{{item.update_at}}</p>
            </li>
            <li class="clearfix">
              <span class="title fl">作品描述</span>
              <p class="fl" v-html="item.tip"></p>
            </li>
            <li class="clearfix">
              <span class="title fl">&nbsp;</span>
              <p class="fl" v-if="item.online_status === 'is_publish'"><router-link :to="{path:'/s-mart/application/'+item.app_id+'/detail'}">查看详情 <i><img src="../../../images/personal_center/download-details.png" alt="" /></i></router-link></p>
              <p class="fl" v-if="item.online_status === 'is_down'"><router-link to="/s-mart/no_collect" target="_blank">查看详情 <i><img src="../../../images/personal_center/download-details.png" alt="" /></i></router-link></p>
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <button type="button" class="loading-more" :disabled="use" v-show="page.totalPage > 1" @click="more(page)">{{this.load_more}}</button>
  </div>

  <!-- <div class="download-list clearfix" v-for="item in download_list" v-if="page.total!=0">
    <div class="fl">
      <img :src="item.app_logo" alt="" />
    </div>
    <div class="right-wrapper">
      <h5>{{item.app_name}}<span class="green">免费</span></h5>
      <div class="download-details more"><span>展开</span><i></i></div>
      <p>{{item.tip}}</p>
      <ul class="download-infor">
        <li class="clearfix">
          <span class="title fl">作品人</span>
          <p class="fl">{{item.user_name}}</p>
        </li>
        <li class="clearfix">
          <span class="title fl">作品类型</span>
          <p class="fl">{{item.sys_type}}</p>
        </li>
        <li class="clearfix">
          <span class="title fl">作品价格</span>
          <p class="fl">免费</p>
        </li>
        <li class="clearfix">
          <span class="title fl">服务支持</span>
          <p class="fl">{{item.support}}（<span class="green">{{item.is_expired}}</span>）</p>
        </li>
        <li class="clearfix">
          <span class="title fl">下载日期</span>
          <p class="fl">{{item.download_at}}</p>
        </li>
        <li class="clearfix">
          <span class="title fl">更新时间</span>
          <p class="fl">{{item.expire_at}}</p>
        </li>
        <li class="clearfix">
          <span class="title fl">作品描述</span>
          <p class="fl">{{item.tip}}</p>
        </li>
        <li class="clearfix">
          <span class="title fl">&nbsp;</span>
          <p class="fl"><a href="javascript:;">查看详情 <i><img src="../../../images/personal_center/download-details.png" alt="" /></i></a></p>
        </li>
      </ul>
    </div>
  </div> -->
  <!-- <div class="download-list clearfix">
    <div class="fl">
      <img src="../../../images/personal_center/works-List02.png" alt="" width="88" height="88" />
    </div>
    <div class="right-wrapper">
      <h5>保健专家 <span class="tip"><strong class="orange">95</strong>  现金</span></h5>
      <div class="download-details more"><span>展开</span><i></i></div>
      <p>这是一款专为运维人员而设计的导航系统，他能够帮助运维快速的定位到工作所需的工具或系统，帮自动根据用户习惯自定义适配系统设置</p>
      <ul class="download-infor">
        <li class="clearfix">
          <span class="title fl">作品人</span>
          <p class="fl">蓝鲸官方</p>
        </li>
        <li class="clearfix">
          <span class="title fl">作品类型</span>
          <p class="fl">应用系统</p>
        </li>
        <li class="clearfix">
          <span class="title fl">作品价格</span>
          <p class="fl">免费</p>
        </li>
        <li class="clearfix">
          <span class="title fl">服务支持</span>
          <p class="fl">五年内免费版本升级（<span class="green">有效期内</span>）</p>
        </li>
        <li class="clearfix">
          <span class="title fl">下载日期</span>
          <p class="fl">2016-11-26 20:35:07</p>
        </li>
        <li class="clearfix">
          <span class="title fl">下载日期</span>
          <p class="fl">2016-12-18 21:28:04</p>
        </li>
        <li class="clearfix">
          <span class="title fl">作品描述</span>
          <p class="fl">这是一款专为运维人员而设计的导航系统，他能够帮助运维快速的定位到工作所需的工具或系统，帮自动根据用户习惯自定义适配系统设置。</p>
        </li>
        <li class="clearfix">
          <span class="title fl">&nbsp;</span>
          <p class="fl"><a href="javascript:;">查看详情 <i><img src="../../../images/personal_center/download-details.png" alt="" /></i></a></p>
        </li>
      </ul>
    </div>
  </div> -->
  <div class="content-none" v-else>
    <img src="../../../images/personal_center/work-null.png" alt="" />
    <p>未下载任何作品，<router-link to="/s-mart/market">随便逛逛</router-link></p>
  </div>
   <div class="content-none" v-else>
     <img src="../../../images/personal_center/work-null.png" alt="" />
     <p>你所访问的作品已下架或删除，点击<router-link to="/s-mart/market" target="_blank">市场</router-link>查看其他作品。</p>
   </div>
</div>
</template>

<script type="text/javascript">
  export default {
    props: {
      total: {
        type: Object,
        default: {
          total: 0
        }
      }
    },
    data() {
      return{
        download_list:[],//获取我的下载列表
        page: {},
        load_more:"加载更多",
        use:false,
        show: false
      }
    },
    methods: {
      getDownloadList(){ //获取我的下载列表
        axios.post(myUrl + 'sns/download/product/').then((res) => {
          res = res.data;
          if(res.result){
            this.download_list = res.data.items;
            this.page = res.data.page;
            this.total.total = res.data.page.total;  // 返回总数
          } else {
            console.log(res.message);
          }
        })
      },
      // 获取更多
      more(page){
        this.page.curPage++;
        axios.post(myUrl + 'sns/download/product/', qs.stringify({"page":this.page.curPage})).then((res)=>{
          res =  res.data;
          if (res.result){
            this.download_list = this.download_list.concat(res.data.items);
            if(res.data.page.curPage == res.data.page.totalPage){
              this.load_more = "没有更多内容了";
              this.use = true;
            }
          } else {
            console.log(res.message);
          }
        })
      },

      initList() {
        $(".download").on('click','.download-details', function() { //作品列表
          if($(this).children('span').text()=='展开'){
              $(this).children('span').text('收起');
              $(this).siblings('p').hide();
              $(this).siblings('.download-infor').slideDown();
          }else{
              $(this).children('span').text('展开');
              $(this).siblings('.download-infor').slideUp(() => {
                $(this).siblings('p').fadeIn();
              })
          }
          $(this).toggleClass('more');
        })
      }
    },
    mounted() {
      this.getDownloadList();
    },
    created() {
      this.$nextTick(() => {
        this.initList();
      })
    }
  }
</script>

<style media="screen" lang="scss">
.slide-enter-active {
  animation: slide-in .3s ease;
}
.slide-leave-active {
  animation: slide-out .3s ease;
}
@keyframes slide-in {
  0% {
    height:0;
    padding-top:0;
    padding-bottom:0;
    margin-top:0;
  }
  100% {
    height:130px;
    padding-top:17px;
    padding-bottom:17px;
    margin-top:20px;
  }
}
@keyframes slide-out {
  0% {
    height:130px;
    padding-top:17px;
    padding-bottom:17px;
    margin-top:20px;
  }
  100% {
    height:0;
    padding-top:0;
    padding-bottom:0;
    margin-top:0px;
  }
}
  .bk-personal_center{
    .download{
      min-height: 640px;
      padding: 15px 45px 65px;
      h4{
        padding: 20px 0;
        font-size: 18px;
        font-weight: bold;
        color: #77787f;
        border-bottom: 1px solid #f4f4f4;
      }
    }
    .download-list{
      margin-top: 27px;
      padding-bottom: 28px;
      border-bottom: 1px solid #f4f4f4;
      .green{
        color: #70c035;
      }
      .overdue{
        color: #ff6600;
      }
      .orange{
        font-size: 18px;
        color: #ff6600;
      }
      .right-wrapper{
        width: 708px;
        float: right;
        position: relative;
        min-height: 0;
        h5{
          font-size: 16px;
          color:#444444;
          line-height: 36px;
          span{
            font-size: 16px;
            font-weight: bold;
            float: right;
          }
          .tip{
            font-size: 12px;
            color: #aaaaaa;
            font-weight:normal;
          }
        }
        > p{
          line-height: 22px;
          width: 550px;
          font-size: 12px;
          color: #888888;
        }
        .download-details{
          cursor: pointer;
          color: #57a3f1;
          position: absolute;
          right: 0px;
          top: 38px;
          i{
            display: inline-block;
            vertical-align: middle;
            width: 14px;
            height: 14px;
            background: url(../../../images/personal_center/download-more.png)no-repeat center center;
            margin-left: 15px;
            -webkit-transition: -webkit-transform 0.2s ease-out;
            -moz-transition: -moz-transform 0.2s ease-out;
            -o-transition: -o-transform 0.2s ease-out;
            -ms-transition: -ms-transform 0.2s ease-out;
          }
          &.more{
            i{
              -webkit-transform: rotateZ(180deg);
              -moz-transform: rotateZ(180deg);
              -o-transform: rotateZ(180deg);
              -ms-transform: rotateZ(180deg);
              transform: rotateZ(180deg);
            }
          }
        }
        .download-infor{
          display: none;
          font-size: 12px;
          padding: 15px 0 0 0;
          li{
            margin-bottom: 10px;
          }
          p{
            color: #888888;
            width:540px;
            line-height: 20px;
            a{
              color: #57a3f1;
              i{
                margin-left: 5px;
              }
            }
          }
          .title{
            min-width: 50px;
            margin-right: 27px;
            color: #b8b8b8;
            line-height: 17px;
          }
        }
      }
    }
    .loading-more{
      margin-top: 30px;
      width: 100%;
      height: 42px;
      line-height: 42px;
      border: 1px solid #f4f4f4;
      text-align: center;
      font-size: 14px;
      color: #828282;
      background: #fff;
      outline:none;
      &:hover{
        background: #fafafa;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// download.vue?c2e51652